var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("input", {
    staticClass: "input",
    attrs: {
      type: _vm.type,
      placeholder: _vm.placeholder,
      readonly: _vm.readonly,
      required: _vm.required,
      disabled: _vm.disabled,
    },
    domProps: { value: _vm.value },
    on: { input: _vm.input },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }